/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6V16H4V6H20ZM20 4H4C3.46957 4 2.96083 4.21072 2.58575 4.58579C2.21068 4.96087 2 5.46957 2 6V16C2 16.5304 2.21068 17.0391 2.58575 17.4142C2.96083 17.7893 3.46957 18 4 18H20C20.5304 18 21.0391 17.7893 21.4142 17.4142C21.7893 17.0391 22 16.5304 22 16V6C22 5.46957 21.7893 4.96087 21.4142 4.58579C21.0391 4.21072 20.5304 4 20 4Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 19H15.5C16.0304 19 16.5391 19.2107 16.9142 19.5858C17.2893 19.9609 17.5 20.4696 17.5 21H6.5C6.5 20.4696 6.71068 19.9609 7.08575 19.5858C7.46083 19.2107 7.96957 19 8.5 19Z",
  fill: "currentColor"
})), 'CategoryET');